import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  dustClasses: "Dust.DustClasses",
  list: "Dust.DustClassList",

  base: "Dust.DustClassBase",
  view: "Dust.DustClassView",

  documents: "Dust.DustClassDocuments",
  documentsEdit: "Dust.DustClassDocumentsEdit",
  documentsNew: "Dust.DustClassDocumentsNew",
  notes: "Dust.DustClassNotes",
  noteEdit: "Dust.DustClassNoteEdit",
  noteNew: "Dust.DustClassNoteNew",
  // audit: "Dust.DustClassAudit",
};

export { names as dustRouteNames };

const dustRoutes: RouterOptions["routes"] = [
  {
    path: "/dust",
    name: names.dustClasses,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Classes",
          lookupGroups: ["DustClassType"],
        },
        component: () => import("@/views/dustClass/DustClassList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/dustClass/DustClassBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Dust Class View" },
            component: () => import("@/views/dustClass/DustClassView.vue"),
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Dust Class Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="dustClass" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Dust Class Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="dustClass" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Dust Class Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="dustClass" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Dust Class Notes" },
            component: {
              render: () => <EntityNotes idField="dustClassId" routeNamePrefix="Dust.DustClassNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Dust Class Note", isForm: true },
            component: () => import("@/views/dustClass/DustClassNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Dust Class Note", isForm: true },
            component: () => import("@/views/dustClass/DustClassNote.vue"),
          },
          // {
          //   path: "activity",
          //   name: names.audit,
          //   meta: { title: "Dust Class Audit Activity" },
          //   component: {
          //     render: () => <EntityAudit entityType="DustClass" />,
          //   },
          // },
        ],
      },
    ],
  },
];
export default dustRoutes;
